/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shubh Jalui",
  title: "Hello, I'm Shubh",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🧑🏽‍💻 & Cybersecurity Enthusiast 🛡️🔐 with experience building robust web and mobile applications using React.js, Node.js and FastAPI. I am also deeply involved in Data Science & Analytics, leveraging tools like Power BI. I am always eager to bridge the gap between modern web development and AI, integrating data-driven insights and scalable pipelines into seamless user experiences."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1fw8oRpnPS-2hE7rK9RXko98lDBfCh7zk/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/sJalui",
  linkedin: "https://in.linkedin.com/in/shubh-jalui-1923b1259",
  gmail: "jaluishubh@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("🛠️ Develop highly interactive Front-end / User Interfaces using React and modern web technologies"),
    emoji("⚙️ Architect robust backend systems and automated data ingestion pipelines using FastAPI, Flask, and Django"),
    emoji("🧠 Train and integrate Machine Learning models (like deep learning segmentation) into production-ready platforms"),
    emoji("📡 Build IoT middleware to process real-time sensor data using tools like Mosquitto and Raspberry Pi"),
    emoji("🚀 Deploy scalable web applications and AI tools on AWS with CI/CD pipelines"),
    emoji("⚡ Manage databases and optimize performance using SQL and SQLAlchemy")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
    {
      skillName: "github-actions",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "gitlab",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    {
      skillName: "dockerhub",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "KJ Somaiya College of Engineering",
      logo: require("./assets/images/kj-logo.png"),
      subHeader: "Bachelor's of Technology in Computer Engineering",
      duration: "July 2022 ~ September 2026",
      desc: "Architected and deployed a fully functional Security Operations Center (SOC) for the Special Interest Group (SIG) at Somaiya Vidyavihar University.",
      descBullets: [
      "Designed the core SOC architecture, integrating robust SIEM solutions for real-time log aggregation and threat detection.",
      "Implemented SOAR workflows to automate incident response, significantly reducing manual triage time for security alerts.",
      "Configured custom alert rules and dashboards to monitor network traffic and secure infrastructure environments."
                  ]
    },
    {
      schoolName: "Wilson College",
      logo: require("./assets/images/Wilson-logo.png"),
      subHeader: "12th Grade",
      duration: "May 2020 ~ March 2022",
    },
    {
      schoolName: "G.D. Somani Memorial School",
      logo: require("./assets/images/GD-logo.png"),
      subHeader: "10th Grade",
      duration: "~ March 2020",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    },
    {
      Stack: "Cloud",
      progressPercentage: "80%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "75%"
    },
    {
      Stack: "Data Science",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "1Accord",
      companylogo: require("./assets/images/1accord_logo.jpg"),
      date: "Jan 2026 – Present",
      desc: "Spearheaded the development of scalable web architectures and automated data ingestion pipelines for hardware integration.",
      descBullets: [
        "Architected end-to-end IoT logistics solutions, seamlessly integrating hardware sensors with React frontends and FastAPI backends via MQTT (Mosquitto) protocols for real-time telemetry.",
        "Spearheaded the development of scalable web architectures, automating data ingestion pipelines to eliminate manual data entry and improve hardware-to-cloud sync reliability.",
        "Engineered robust full-stack solutions and backend middleware to seamlessly bridge physical devices with enterprise web interfaces."
      ]
    },
    {
      role: "QA/QC",
      company: "MSgames",
      companylogo: require("./assets/images/msgames.png"),
      date: "Dec 2025 – Present",
      desc: "Ensured software quality, reliability, and performance through comprehensive testing and quality assurance protocols.",
      descBullets: [
        "Executed rigorous Quality Assurance testing on complex backend data systems and API middleware, identifying critical bottlenecks to ensure cross-platform application stability.",
        "Designed and implemented comprehensive test cases to validate high-throughput endpoints, directly assisting developers in rapid bug resolution.",
        "Maintained high data integrity and optimal application performance through meticulous bug tracking and quality control protocols."
      ]
    },
    {
      role: "Data Visualization Intern",
      company: "Infosys Springboard",
      companylogo: require("./assets/images/infosys.webp"),
      date: "May 2025 – Aug 2025",
      desc: "Applied machine learning techniques and data visualization tools to derive actionable insights from complex datasets.",
      descBullets: [
        "Engineered dynamic, interactive Power BI dashboards from large-scale corporate datasets, transforming raw metrics into actionable insights for strategic leadership.",
        "Executed comprehensive data cleaning and processing workflows to ensure high data fidelity, directly supporting enterprise-level data-driven decision-making.",
        "Trained and evaluated machine learning models on complex financial datasets to generate predictive business intelligence."
      ]
    },
    {
      role: "Data Science Intern",
      company: "Externsclub",
      companylogo: require("./assets/images/externs.jpg"), 
      date: "May 2025 – Aug 2025",
      desc: "Applied machine learning techniques and data analytics to derive actionable insights from complex financial records.",
      descBullets: [
        "Trained and optimized predictive machine learning pipelines to securely parse and validate over 300,000 complex financial transaction records.",
        "Leveraged advanced data analytics and feature engineering to automate the identification of irregular trends and fraud patterns.",
        "Directly informed proactive risk management strategies by translating large-scale financial data into dynamic, interactive visual reports."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH ALONGSIDE MY PRIVATE PROJECTS.",
  projects: [
    {
      image: require("./assets/images/finedge.png"),
      projectName: "FinEdge",
      projectDesc: "FinEdge is an AI-powered platform that helps users manage and optimize their personal finances. It solves the problem of scattered tools and lack of personalized guidance. By centralizing financial data, it delivers tailored, actionable advice for each user.",
      footerLink: [
        {
          name: "View on GitHub(Live Preview Available)",
          url: "https://github.com/sJalui/FinEdge"
        }
      ]
    },
    {
      image: require("./assets/images/luxh.png"),
      projectName: "Luxury Haven",
      projectDesc: "A luxury real estate platform designed for high-end property listings, featuring an elegant user interface and comprehensive property management tools.",
      footerLink: [
        {
          name: "View on GitHub(Live Preview Available)",
          url: "https://github.com/sJalui/LuxuryHaven"
        }
      ]
    },
    {
      image: require("./assets/images/meb-gland.jpeg"),
      projectName: "1accordeyecare (NDA)",
      projectDesc: "A specialized clinical platform developed for seamless operations, featuring analysis with respect to the eye which is used alongside the company's own device.",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://1accordeyecare.eu.cc"
        }
      ]
    },
    {
      image: require("./assets/images/feature-image-dark-store.jpeg"),
      projectName: "IoT Pick-to-Light WMS (NDA)",
      projectDesc: "An enterprise Warehouse Management System utilizing Raspberry Pi Pico, MQTT (Mosquitto), and a FastAPI backend for real-time hardware-integrated inventory control.",
      footerLink: [
        {
          name: "Currently Under Work (NDA)",
          url: ""
        }
      ] 
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle:
    "Certifications that I have completed !",

  achievementsCards: [
    {
      title: "Google Cybersecurity Professional Certificate V2",
      subtitle:
        "The official badge from Google for the completion of the Google Cybersecurity Certificate program with the Credly badge.",
      image: require("./assets/images/google-cyber.png"),
      imageAlt: "Google Cybersecurity Certificate Logo",
      footerLink: [
        {
          name: "View Credly Badge Link",
          url: "https://www.credly.com/badges/7d4e46f3-cb62-4acd-ae5d-39a9dce55fb7/public_url"
        }
      ]
    },
    {
      title: "Google Cloud Cybersecurity Certificate",
      subtitle:
        "The official badge from Google Cloud Career Launchpad program with the Credly badge.",
      image: require("./assets/images/google-cloud.png"),
      imageAlt: "Google Cloud Cybersecurity Certificate Logo",
      footerLink: [
        {
          name: "View Credly Badge Link",
          url: "https://www.credly.com/badges/33c18f55-e12d-46da-b9dd-467252525f0c/public_url"
        }
      ]
    },
    {
      title: "Infosys Springboard Data Visualization Completion Certificate",
      subtitle:
        "Internship completion certificate from the Infosys Springboard program",
      image: require("./assets/images/infy.jpg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://infyspringboard.onwingspan.com/public-assets/infosysheadstart/cert/lex_auth_01424381801112371247/1-a748e795-457b-418e-b597-6fa6431a3775.pdf"
        }
      ]
    },
    {
      title: "Externsclub Data Science Completion Certificate",
      subtitle:
        "Internship completion certificate from the Externsclub Data Science program",
      image: require("./assets/images/externs.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://certificate.givemycertificate.com/c/9fbbd67d-07de-48ac-9bd3-71be431266e5"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me 📧"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "jaluishubh@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
